import React, { useEffect, useState } from 'react'
import { Button, Divider, FloatButton, Tooltip } from 'antd'
import { ArrowLeftOutlined, CheckOutlined, CloseOutlined, ExclamationCircleOutlined, InfoOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';

import POKEBALLGACHA from '../../../Assets/pokeball-gacha.png'
import MASTERBALLGACHA from '../../../Assets/masterball-gacha.png'
import ULTRABALLGACHA from '../../../Assets/ultraball-gacha.png'
import { useRef } from "react";
import { useListarZonasGachapon } from "../../../Hooks/Player";
const POKESPRITEURL = import.meta.env.VITE_POKESPRITES_GIT_URL;

import pokeFondo from "../../../Assets/6R0Q1DU.jpeg";

import {
    ContainerDiv,
    Container,
    GashaImg,
    ModalBackground,
    ModalContainer,
    ModalImgDiv,
    ModalImg,
    ModalTitle,
    ModalPull,
    ModalPullTitle,
    HorizontalList,
    PoolImgWithStar,
    ModalButtonContainer,
    ModalButton,
    ModalBall,
    ModalConfirmContainer,
    ModalConfirm,
    ModalContainerCoins,
    CoinsDiv,
    ZonaContainer,
    ZonaTitle,
    GlobalStyle
} from './styles'

export const GashaponList = () => {
    const navigate = useNavigate();

    const {data, refetch, isFetching} = useListarZonasGachapon();
    const [modal, setModal] = useState([false, []]);
    const handleModal = (item, img, color) => {
        setModal([true, item, img, color, data.fichas])
    }
    const [imageCache, setImageCache] = useState({});
    // Precargar imágenes
    useEffect(() => {
        const cache = {};
        data && data.gachapon.map(gacha => {
                gacha.pokemons.map(item => {
                    const url = POKESPRITEURL + item.poke_nombre.toLowerCase() + ".png";
                    const img = new Image();
                    img.src = url;
                    cache[item.poke_id] = img.src;
                
            })
        });
        setImageCache(cache);
    }, [!isFetching]);

    return (
        <>
            <ContainerDiv img={pokeFondo}>
                {
                    modal[0] && <GashaponModal item={modal} setModal={setModal} imgCache={imageCache}/>
                }
                <Container>
                    <FloatButton icon={<ArrowLeftOutlined />} style={{ left: 10, top: 10, marginBottom: "5%" }} onClick={() => navigate("/home")}/>
                    {
                        // data && data.zonas.map(
                        //     (item, index) => (
                        //         <ZonaContainer color={item.zona_color_card}>
                        //             <ZonaTitle>{item.zona_nombre}</ZonaTitle>
                                    // {
                                        data && data.gachapon.map((item2, index2) => 
                                            <GashaImg color={'rgb(44, 62, 80)'} onClick={() => handleModal(item2, item2.gacha_imagen, 'rgb(44, 62, 80)')} key={index2}>
                                                <img src={item2.gacha_imagen}/>
                                                <h1>{item2.gacha_codigo}</h1>
                                            </GashaImg>)
                                    // }
                                // </ZonaContainer>
                            // )
                        // )
                    }
                </Container>
            </ContainerDiv>
        </>
    )
}

const GashaponModal = ({item, setModal, imgCache}) => {
    const [modalConfirm, setModalConfirm] = useState([false, [], null]);
    const startVibration = () => {
      if (navigator.vibrate) {
        navigator.vibrate(100); // Vibra por 100ms
      }
    };
    const stopVibration = () => {
      if (navigator.vibrate) {
        navigator.vibrate(0); // Detiene la vibración
      }
    };
    const listRef = useRef(null);
    const handleScroll = () => {
      if (listRef.current) {
        listRef.current.classList.add("vibrating");
        startVibration();
        setTimeout(() => {
          listRef.current.classList.remove("vibrating");
          stopVibration()
        }, 200); // Tiempo de la animación
      }
    };

    const handleClick = (coin, background, cantidad) => {
        setModalConfirm([true, item[1], coin, background, cantidad]);
    }
    const texto = () => (
        <span>
            <strong>La PokeBall</strong> canjea 1 tirada.<br />
            <strong>La SuperBall</strong> canjea 2 tiradas.<br />
            <strong>La UltraBall</strong> canjea 3 tiradas.<br />
            <em>Independiente de la cantidad de tiradas, solo te quedarás con 1 Pokémon.</em>
        </span>
    )

    const pokeballs = [
        POKEBALLGACHA,
        MASTERBALLGACHA,
        ULTRABALLGACHA
    ]
    return (
        <ModalBackground>
            <GlobalStyle />
            <Tooltip placement="bottomLeft" title={texto}>
                <FloatButton icon={<InfoOutlined />} style={{ right: 20, top: 10, marginBottom: "5%" }}/>
            </Tooltip>
            <ModalContainer>
                <ModalImgDiv>
                    <ModalImg src={item[2]}/>
                    <ModalTitle>{item[1].gacha_codigo}</ModalTitle>
                </ModalImgDiv>

                <ModalPull  ref={listRef}>
                    <ModalPullTitle>{'POOL'}</ModalPullTitle>
                    <HorizontalList  onScroll={handleScroll}>
                        {
                            item[1].pokemons && item[1].pokemons.map(pooled => <PoolImgWithStar>
                                <img src={imgCache[pooled.poke_id]}/>
                                <div style={{marginLeft: '15px'}}>
                                    {pooled.pozo_rareza < 4 ? Array.from({ length: pooled.pozo_rareza }).map((_, index) => (
                                        <span key={index}>⭐</span>
                                    )) : <span key={1}>✴️</span>}
                                </div>
                                </PoolImgWithStar>)
                        }
                    </HorizontalList>
                </ModalPull>
                <ModalButtonContainer>
                    {
                        item[4] && item[4].map((coin,index) => 
                        <ModalButton color={item[3]} onClick={() => handleClick(coin.idObjeto, item[2], coin.cantidad)}>
                            <ModalBall src={pokeballs[index]}/>
                            {'x'+(index+1)}
                        </ModalButton>
                        )
                    }
                </ModalButtonContainer>
                <Divider style={{ transform: 'translateY(15px)' }} />

                <Button type="primary" danger shape="round" icon={<CloseOutlined />} size='large' style={{width: '93%', position: 'absolute', bottom: '0', marginBottom: '10px'}} onClick={() => setModal([false, []])}>{'Cerrar'}</Button>
            </ModalContainer>
            
            <ModalContainerCoins>
                
                <CoinsDiv>
                    <strong>Mis monedas: </strong>
                </CoinsDiv>
                {
                    item[4].map((monedas, index) => 
                        <CoinsDiv>
                            <img src={pokeballs[index]} style={{width: '20px', marginRight: '2px'}}/> 
                            <p>{'x'+monedas.cantidad}</p>
                        </CoinsDiv>)
                }
            </ModalContainerCoins>
            {
                modalConfirm[0] && <GashaponModalConfirm setModalConfirm={setModalConfirm} item={modalConfirm} />
            }
        </ModalBackground>
    )
}


const GashaponModalConfirm = ({setModalConfirm, item}) => {
    return (
        <ModalConfirmContainer>
            <ModalConfirm>
                <ExclamationCircleOutlined style={{ fontSize: '80px', color: '#1677ff' }}/>
                <p style={{fontSize: '1rem'}}>¿Estás seguro de hacer el canje?</p>
                <Divider style={{ transform: 'translateY(20px)' }} />
                <div style={{display: 'flex', justifyContent:'stretch', alignItems: 'center', width: '93%', position: 'absolute', bottom: '0', marginBottom: '10px'}}>
                    <Button type="primary" danger shape="round" icon={<CloseOutlined />} size='large' style={{width: '90%', marginRight: '5px'}} onClick={() => setModalConfirm([false,[],null])}>{'Cerrar'}</Button>
                    <Link to={'open'} state={{ gacha_id: item[1].id, coin_id: item[2], pokemons: item[1].pokemons, background: item[3] }} style={{width: '100%'}}>
                        <Button type="primary" success shape="round" icon={<CheckOutlined />} size='large' style={{width: '100%'}} disabled={item[4] > 0 ? false : true} >{'Canjear'}</Button>
                    </Link>
                </div>
            </ModalConfirm>
        </ModalConfirmContainer>
    )
}